module.exports = __webpack_public_path__ + "img/9.18d816c8.svg";